import { Space, Table } from "antd";
import { useTranslation } from "react-i18next";
import EditButton from "../UI/EditButton/editbutton";
import DeleteButton from "../UI/DeleteButton/deletebutton";
import { ColumnsType } from "antd/es/table";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { UseMutateAsyncFunction } from "react-query";
import { AxiosResponse } from "axios";
import { format } from "date-fns";

interface SalesDataProps {
  isSalesDataLoading: boolean;
  salesData: [] | undefined;
  setSalesData: Dispatch<SetStateAction<[] | undefined>>;
  setPage: Dispatch<SetStateAction<number>>;
  SalesDataMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    {
      limit: number;
      q: string;
    },
    unknown
  >;
  page: number;
  tableKey: string;
  search: string;
}
interface SalesInterface {
  key: React.Key;
  date: string;
  invoices: string;
  bill: string;
  Activetime: string;
  amount: string;
  currency: string;
  rate: string;
}
const SalesList = ({
  isSalesDataLoading,
  salesData,
  setSalesData,
  setPage,
  page,
  tableKey,
  search,
  SalesDataMutation,
}: SalesDataProps) => {
  const { t } = useTranslation("common");
  const [prevPage, setPrevPage] = useState<number>(0);
  const [maxPage, setMaxPage] = useState<number>(0);

  useEffect(() => {
    page > prevPage &&
      maxPage < page &&
      SalesDataMutation({
        limit: page * 10 + 10,
        q: search,
      }).then((res) => {
        if (page > maxPage) setMaxPage(page);
        setSalesData(res.data.data);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const columns: ColumnsType<SalesInterface> = [
    {
      title: `${t("date")}`,
      dataIndex: "date",
      key: "date",
      width: "10rem",
      className: "table-header",
      render: (date: any) => {
        return format(new Date(date), "MM/dd/yyyy HH:mm");
      },
    },
    {
      title: `${t("invoices")}`,
      dataIndex: "invoiceNo",
      key: "invoiceNo",
      width: "10rem",
    },
    {
      title: `${t("amount")}`,
      dataIndex: "amountText",
      key: "amountText",
      width: "10rem",
    },
    {
      title: `${t("rate")}`,
      dataIndex: "exchangeRate",
      key: "exchangeRate",
      width: "8rem",
    },

    {
      title: `${t("currency")}`,
      dataIndex: "currency",
      key: "currency",
      width: "12rem",
      render: (record: any) => {
        return record ? record.name : null;
      },
    },
    {
      title: `${t("note")}`,
      dataIndex: "notes",
      key: "notes",
    },
    {
      title: `${t("action")}`,
      key: "action",
      width: "10rem",
      align: "center" as "center",
      render: (record: any) => (
        <>
          <EditButton
            onClick={() => {
              ("");
            }}
          />
          <DeleteButton
            onClick={() => {
              ("");
            }}
          />
        </>
      ),
    },
  ];
  return (
    <>
      <Table
        loading={isSalesDataLoading}
        dataSource={salesData}
        scroll={{ x: 1000 }}
        columns={columns}
        rowClassName={(record, index) =>
          index % 2 === 0
            ? "table-row-light table-row"
            : "table-row-dark table-row"
        }
        onChange={(selectedPage) => {
          setPrevPage(page);
          setPage(selectedPage?.current ?? 1);
        }}
        rowKey={(record: any) => record.id}
      />
    </>
  );
};

export default SalesList;
